import { AxiosResponse, Canceler } from 'axios';
import { IFreeStorySchedule, IFreeStoryScheduleCreator } from '../types';
import settings from '../settings';
import api from './base';

export function getFreeStorySchedules(params: { page?: number; limit?: number }): [Promise<AxiosResponse<IFreeStorySchedule[]>>, Canceler] {
  const uri = `${settings.getApiURI()}/story/v2/free-event-schedules`;

  return api.getWithCancel(uri, {
    params: {
      page: 1,
      limit: 20,
      ...params,
    },
  });
}

export function createFreeStorySchedule(payload: Partial<IFreeStoryScheduleCreator>) {
  const uri = `${settings.getApiURI()}/story/v2/free-event-schedules`;
  return api.http.post(uri, payload);
}

export function deleteFreeStorySchedule(id: number) {
  const uri = `${settings.getApiURI()}/story/v2/free-event-schedules/${id}`;

  return api.http.delete(uri);
}
